"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ChatInterface_1 = require("./ChatInterface");
class MessageFactoryImpl {
    constructor(clock) {
        this.make = (authorId, authorDisplayName, body, timeZone, id = null, attachment) => ({
            authorId,
            authorDisplayName,
            level: null,
            message: {
                id,
                messageParts: [
                    {
                        name: ChatInterface_1.MessagePartType.TEXT,
                        text: body,
                    },
                ],
                isoDateTime: this.clock.currentRaw(timeZone).date,
                attachment,
            },
        });
        this.clock = clock;
    }
}
exports.default = MessageFactoryImpl;
//# sourceMappingURL=MessageFactory.js.map